import React from 'react'
import {
  getGridStringOperators,
  getGridNumericOperators,
  getGridBooleanOperators,
  useGridApiContext,
  getGridDateOperators
} from "@mui/x-data-grid";
import {
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


export const CustomerFilterPanel = ({ columns }) => {
  const apiRef = useGridApiContext();

  const initialFilterModel =
    apiRef.current.state.filter?.filterModel || {
      items: [],
    };

  const [currentItem, setCurrentItem] = React.useState(
    initialFilterModel.items?.[0] || null,
  );

const [focusedSelect, setFocusedSelect] = React.useState(null)

  const filterableColumns = columns.filter(
    (column) =>
      column.filterable !== false &&
      column.field !== "__check__" &&
      column.field !== "actions",
  );

  // ---------------------------------------------------------
  // Get operators based on column type
  // ---------------------------------------------------------

  const getOperators = (column) => {
    if (!column) {
      return getGridStringOperators();
    }

    if (
      Array.isArray(column.filterOperators) &&
      column.filterOperators.length > 0
    ) {
      return column.filterOperators;
    }

    switch (column.type) {
      case "number":
        return getGridNumericOperators();

      case "boolean":
        return getGridBooleanOperators();

      case "date":
        return getGridDateOperators();

      // case "dateTime":
      //   return getGridDateTimeOperators();

      default:
        return getGridStringOperators();
    }
  };

  // ---------------------------------------------------------
  // Update filter
  // ---------------------------------------------------------

  const updateFilter = (updates) => {
    if (!currentItem) {
      return;
    }

    const updatedItem = {
      ...currentItem,
      ...updates,
    };

    // Update local UI immediately
    setCurrentItem(updatedItem);

    // Update DataGrid filter
    apiRef.current.upsertFilterItem(updatedItem);
  };

  // ---------------------------------------------------------
  // Remove filter
  // ---------------------------------------------------------

  const removeFilter = () => {
    if (!currentItem) {
      return;
    }

    // Compatible with your DataGrid version
    const filterModel =
      apiRef.current.state.filter?.filterModel || {
        items: [],
      };

    apiRef.current.setFilterModel({
      ...filterModel,
      items: filterModel.items.filter(
        (filterItem) =>
          filterItem.id !== currentItem.id,
      ),
    });

    setCurrentItem(null);
  };

  // ---------------------------------------------------------

  if (!currentItem) {
    return null;
  }

  const selectedColumn =
    columns.find(
      (column) =>
        column.field === currentItem.field,
    ) || filterableColumns[0];

  const operators =
    getOperators(selectedColumn);

  return (
    <div
      style={{
        width: "560px",
        backgroundColor: "#ffffff",
        padding: "8px 0 8px",
        boxSizing: "border-box",
      }}
    >
      {/* HEADER */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "25px 1.2fr 1fr 1.2fr",
          columnGap: "8px",
          alignItems: "center",
          padding: "0 12px 4px",
          fontSize: "12px",
          color: "#757575",
        }}
      >
        <div />

        <div style={{ fontSize:"0.9rem",  color: focusedSelect === "data" ? "#1976d2" : "#757575",}}>Columns</div>

        <div  style={{ fontSize:"0.9rem", color: focusedSelect === "operator" ? "#1976d2" : "#757575",}}>Operator</div>

        <div  style={{ fontSize:"0.9rem", color: focusedSelect === "value" ? "#1976d2" : "#757575",}}>Value</div>
      </div>

      {/* FILTER ROW */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "27px 1.2fr 1fr 1.2fr",
          // columnGap: "8px",
          alignItems: "center",
         padding: "0 12px 4px",
        }}
      >
        {/* REMOVE */}

        <IconButton
          size="small"
          onClick={removeFilter}
          sx={{
            width: "32px",
            height: "32px",
            padding: 0,
            color: "#757575",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <CloseIcon
            sx={{
              fontSize: "1.6rem",
            }}
          />
        </IconButton>

        {/* COLUMN */}

        <select
          id="filter-field-select-data"
          value={currentItem.field || ""}
          className="MuiNativeSelect-select MuiNativeSelect-standard MuiInputBase-input MuiInput-input"
        onFocus={() => setFocusedSelect("data")}
  onBlur={() => setFocusedSelect(null)}
          onChange={(event) => {
            const newField =
              event.target.value;

            const newColumn =
              columns.find(
                (column) =>
                  column.field === newField,
              );

            const newOperators =
              getOperators(newColumn);

            updateFilter({
              field: newField,
              operator:
                newOperators[0]?.value ||
                "contains",
              value: "",
            });
          }}
          style={{
            
            width: "100%",
            height: "32px",
            border: "none",
           borderBottom: focusedSelect === "data"
      ? "2px solid #1976d2"
      : "1px solid #9e9e9e",
            backgroundColor: "transparent",
            outline: "none",
            fontSize: "1rem",
            // color: "#424242",
            cursor: "pointer",
            padding: "0 4px",
          }}
        >
          {filterableColumns.map((column) => (
            <option
              key={column.field}
              value={column.field}
            >
              {column.headerName ||
                column.field}
            </option>
          ))}
        </select>

        {/* OPERATOR */}

        <select
          id="filter-field-select-options"
           className="MuiNativeSelect-select MuiNativeSelect-standard MuiInputBase-input MuiInput-input"
          value={currentItem.operator || ""}
        onFocus={() => setFocusedSelect("operator")}
       onBlur={() => setFocusedSelect(null)}
          onChange={(event) => {
            updateFilter({
              operator:
                event.target.value,
            });
          }}
          style={{
             
            width: "100%",
            height: "32px",
            border: "none",
           borderBottom: focusedSelect === "data"
      ? "2px solid #1976d2"
      : "1px solid #9e9e9e",
            backgroundColor: "transparent",
            outline: "none",
            fontSize: "1rem",
            // color: "#424242",
            cursor: "pointer",
            padding: "0 4px",
          }}
        >
          {operators.map((operator) => (
            <option
              key={operator.value}
              value={operator.value}
            >
              {operator.label ||
                operator.value}
            </option>
          ))}
        </select>

        {/* VALUE */}

        {selectedColumn?.filterOptions ? (
          <select
            id="filter-field-select-value"
            className="MuiNativeSelect-select MuiNativeSelect-standard MuiInputBase-input MuiInput-input"
            value={currentItem.value || ""}
             onFocus={() => setFocusedSelect("value")}
             onBlur={() => setFocusedSelect(null)}
            onChange={(event) => {
              updateFilter({
                value:
                  event.target.value,
              });
            }}
            style={{
                
            width: "100%",
            height: "32px",
            border: "none",
           borderBottom: focusedSelect === "data"
      ? "2px solid #1976d2"
      : "1px solid #9e9e9e",
            backgroundColor: "transparent",
            outline: "none",
            fontSize: "1rem",
            // color: "#424242",
            cursor: "pointer",
            padding: "0 4px",
            }}
          >
            <option value="">
              Filter value
            </option>

            {selectedColumn.filterOptions.map(
              (option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              ),
            )}
          </select>
        ) : (
          <input
            type={
              selectedColumn?.type ===
              "number"
                ? "number"
                : "text"
            }
             onFocus={() => setFocusedSelect("value")}
             onBlur={() => setFocusedSelect(null)}
            value={currentItem.value || ""}
            placeholder="Filter value"
            onChange={(event) => {
              updateFilter({
                value:
                  event.target.value,
              });
            }}
            style={{
              width: "100%",
              height: "32px",
              border: "none",
              borderBottom:
                focusedSelect === "value"
      ? "2px solid #1976d2"
      : "1px solid #9e9e9e",
              backgroundColor:
                "transparent",
              outline: "none",
              fontSize: "1rem",
              // color: "#424242",
              padding: "0 6px",
              boxSizing: "border-box",
            }}
          />
        )}
      </div>
    </div>
  );
};

